import { useSelector } from 'react-redux'

import { preview } from '@/components/form/preview'
import { selectTrafficTimeWindows } from '@/features/domain/traffic'

import { getDrivingTimeFactorLabel, isMultipleValues } from '../../../utils'
import { Header } from './components/Header'
import { useTexts } from './hooks/useTexts'
import { useTrafficArea } from './hooks/useTrafficArea'

export function SingleView() {
  const timeWindows = useSelector(selectTrafficTimeWindows)
  const trafficArea = useTrafficArea()
  const texts = useTexts()

  if (!trafficArea) return null

  const levels = [trafficArea.level]

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header trafficArea={trafficArea} />}>
      <preview.Field label={texts.defaultDrivingTime}>
        {isMultipleValues(levels) ? texts.multipleValues : getDrivingTimeFactorLabel(levels[0])}
      </preview.Field>

      {timeWindows.length > 0 && <preview.Divider />}
      {timeWindows.length > 0 && (
        <preview.SectionTitle>{texts.TimeWindowsDrivingTime}</preview.SectionTitle>
      )}

      {timeWindows.map((tw, index) =>
        tw ? (
          <preview.Field key={`tw_${index}`} label={<preview.TimeWindow tw={tw} />}>
            {getDrivingTimeFactorLabel(trafficArea.timeWindowLevels[index])}
          </preview.Field>
        ) : null,
      )}
    </preview.Root>
  )
}
